import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@ui-kitten/components';

import ListItemLoader from '../../../../Components/ListItemLoader';
import { RectangleLoader } from '../../../../Components/Loader';
import themeStyle from '../../../../Theme/styles';

import { styles as baseStyles } from './Base';
import cardStyle from './styles';

function EventCardLoader() {
  const theme = useTheme();
  return (
    <View>
      <View style={themeStyle.spacingBottomMedium}>
        <View
          style={[
            themeStyle.flex1,
            themeStyle.flexDirectionRow,
            themeStyle.spacingBottomMedium,
          ]}
        >
          <View style={[themeStyle.flex1, themeStyle.spacingRightMedium]}>
            {/* Name */}
            <View style={themeStyle.spacingBottomSmall}>
              <RectangleLoader width="100%" height={27.8} />
            </View>
            {/* Distance and tags */}
            <RectangleLoader width={100} height={19.7} />
          </View>
          {/* Bookmark */}
          <RectangleLoader
            width={baseStyles.bookmarkIcon.width}
            height={baseStyles.bookmarkIcon.height}
          />
        </View>
        {/* Image */}
        <View style={baseStyles.image}>
          <RectangleLoader width="100%" height="100%" />
        </View>
      </View>
      {/* Footer */}
      <View
        style={[
          cardStyle.listItemWrapper,
          { borderColor: theme['color-info-500'] },
        ]}
      >
        <View style={themeStyle.spacingBottomSmall}>
          <RectangleLoader height={20.2} width="100%" />
        </View>
        <View style={{ width: '85%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomXXSmall}
            spacing={5}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
        <View style={{ width: '55%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomXXSmall}
            spacing={5}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
        <View style={{ width: '50%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomMedium}
            spacing={5}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
        <View
          style={[
            themeStyle.alignItemsStart,
            {
              borderRadius: 20,
              overflow: 'hidden',
              width: 154,
            },
          ]}
        >
          <RectangleLoader height={40} width="100%" />
        </View>
      </View>
    </View>
  );
}

export default EventCardLoader;
